import React from 'react';
import { useGroupsListInit } from './pagehooks/useGroupsListInit';
import PageTop from '../../../core/components/PageTop';
import GroupsListTable from './table/GroupsListTable';

const PageAdminGroupsList = (): JSX.Element => {
    useGroupsListInit();

    return (
        <>
            <PageTop
                title="Group List"
                icon="sprite-about-corp"
            />
            <div className="groups-feature groups-list">
                <GroupsListTable />
            </div>
        </>
    );
};

export default PageAdminGroupsList;
